import type { Account } from "bonusx-api-main-manager";
import toString from "lodash/toString";
import type { IRegistrySex } from "../../interfaces/IRegistrySex";
import { getBirthDateFromTaxCode, getRegistrySexFromTaxCode } from "../../utils/tax-code-utils";

interface IGTMUserDataAdapter {
  getId(): number;
  getEmail(): string;
  getPhone(): string;
  getFirstName(): string;
  getLastName(): string;
  getBirthDate(): Date;
  getGender(): IRegistrySex;
  getAddress(): string;
  getCity(): string;
  getRegion(): string;
  getPostalCode(): string;
  getCountry(): string;
}

export class GTMUserDataAdapter implements IGTMUserDataAdapter {
  constructor(private account: Account) {}
  getId() {
    return Number(this.account.id);
  }
  getEmail() {
    return toString(this.account.email);
  }
  getPhone() {
    return toString(this.account.phoneNumber);
  }
  getFirstName() {
    return toString(this.account.name);
  }
  getLastName() {
    return toString(this.account.surname);
  }
  getBirthDate() {
    const taxCode = this.account.citizen?.taxCode;
    const birthday = getBirthDateFromTaxCode(taxCode);
    return birthday;
  }
  getGender() {
    const taxCode = this.account.citizen?.taxCode;
    const gender = getRegistrySexFromTaxCode(taxCode);
    return gender;
  }
  getAddress() {
    return "";
  }
  getCity() {
    return "";
  }
  getRegion() {
    return "";
  }
  getPostalCode() {
    return "";
  }
  getCountry() {
    return "";
  }
}
